const PropTypes = require('prop-types');
const React = require('react');
const classNames = require('classnames')
const OTHER_REASON = 'other';

class RefundRequestReason extends React.Component {
  constructor(props) {
    super(props);
    this.state = { refundReason: '' };
    this.handleChange = this.handleChange.bind(this)
  }

  componentDidMount() {
    if (this.props.componentFocus) {
      this.textarea.focus();
    }
  }

  renderOptions() {
    const options = [<option value="" key="prompt">{I18n.t('js.dashboard.refundRequests.selectOne')}</option>];

    Object.keys(this.props.reasons).forEach((text) => {
      const value = this.props.reasons[text];
      options.push(<option value={value} key={value}>{text}</option>);
    });

    return options;
  }

  isRefundReasonRequired() {
    return this.state.refundReason === OTHER_REASON;
  }

  refundReasonClassName() {
    return classNames({
      "wide": true,
      "required": this.isRefundReasonRequired(),
    });
  }

  refundNoteLabelText() {
    if (this.isRefundReasonRequired()) {
      return I18n.t('js.dashboard.refundRequests.noteToBuyerRequired');
    }

    return I18n.t('js.dashboard.refundRequests.noteToBuyer');
  }

  handleChange(event) {
    this.setState({ refundReason: event.target.value });
  }

  render() {
    return (
      <div>
        <div className="g-container">
          <div className="g-col-6 g-col-mobile-12">
            <label htmlFor="order_refund_request_reason">{I18n.t('js.dashboard.refundRequests.reason')}</label>
            <div className="styled-dropdown">
              <select
                id="order_refund_request_reason"
                name="order_refund_request[reason]"
                onChange={this.handleChange}
                required
                className="nochosen"
                data-refund-reason-select>
                {this.renderOptions()}
              </select>
            </div>
          </div>
        </div>

        <div className="mb-1">
          <label htmlFor="order_refund_request_note_to_buyer">{this.refundNoteLabelText()}</label>
          <textarea
            id="order_refund_request_note_to_buyer"
            name="order_refund_request[note_to_buyer]"
            className={this.refundReasonClassName()}
            cols="50"
            rows="2"
            ref={(textarea) => { this.textarea = textarea; }}
          >
          </textarea>
        </div>
      </div>
    );
  }
}

RefundRequestReason.propTypes = {
  reasons: PropTypes.object,
  componentFocus: PropTypes.string,
};

module.exports = RefundRequestReason;



// WEBPACK FOOTER //
// ./javascripts/components/dashboard/refund_request_reason.jsx